interface Props {
  width?: number,
  height?: number,
  hexColor?: string
}

export const ArrowRight = ({ width = 21, height = 16, hexColor = '#ffffff' }: Props) => {
  return (
    <svg width={width} height={height} viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 8.37487L20 8.37487M12.5369 15.3749L19.87 8.28589L12.3332 1" stroke={hexColor} />
    </svg>
  );
};

export default ArrowRight;
